export enum WordGuessLetterStateEnum {
  Empty = 'empty',
  Absent = 'absent',
  Present = 'present',
  Correct = 'correct',
}
